import { Button, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

const CustomAgMultiSelectFilter = (props: any) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [values, setValues] = useState<string[]>([]); // array of selected values
  const [isActive, setIsActive] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  // Open filter popup
  const onFilterIconClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    e.preventDefault();
    props.showParentFilter?.(inputRef.current);
  };

  // Sync with AG Grid filter model
  useEffect(() => {
    const updateValuesFromModel = () => {
      const filterModel = props.api.getFilterModel?.();
      const colId = props.column.getColId?.();
      const model = filterModel?.[colId];

      if (model?.values) {
        setValues(model.values);
        setIsActive(model.values.length > 0);
      } else {
        setValues([]);
        setIsActive(false);
      }
    };

    // Initial check
    updateValuesFromModel();

    // Listen to filter changes
    props.api?.addEventListener('filterChanged', updateValuesFromModel);
    return () => {
      props.api?.removeEventListener('filterChanged', updateValuesFromModel);
    };
  }, [props.api, props.column]);

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
      <Stack
        direction="row"
        sx={{
          border: `1px solid ${theme.palette.borderLight}`,
          borderRadius: `${theme.borderRadius.sm}px`,
          backgroundColor: theme.palette.common.white,
          width: '100%',
          height: '25px',
          gap: '2px',
          overflow: 'hidden',
        }}
        alignItems={'center'}
      >
        <TextField
          value={values.join(', ')} // show selected values
          onClick={onFilterIconClick}
          placeholder={t('common.select')}
          inputRef={inputRef}
          inputProps={{ readOnly: true }}
          sx={{
            flex: 1,
            minWidth: 0,
            '& .MuiOutlinedInput-root': {
              padding: 0,
              boxShadow: 'none',
              paddingLeft: '5px',
              fontSize: '12px',
              cursor: 'pointer',
              '& fieldset': { border: 'none' },
              '&:hover fieldset': { border: 'none' },
              '&.Mui-focused fieldset': { border: 'none' },
            },
            '& .MuiOutlinedInput-root.Mui-focused': {
              boxShadow: 'none',
            },
            '& .MuiOutlinedInput-input': {
              padding: 0,
              height: '20px',
              cursor: 'pointer',
            },
          }}
        />

        {/* Filter icon */}
        <Button
          type="button"
          className="ag-icon ag-icon-filter"
          sx={{
            cursor: 'pointer',
            fontSize: '14px',
            height: '100%',
            width: '20px',
            minWidth: '30px',
            padding: 0,
            borderRadius: '0px',
            backgroundColor: isActive ? theme.palette.leftNavigation.activeBg : 'transparent',
            color: isActive ? theme.palette.primary.main : theme.palette.textMedium,
            transition: `all ${theme.transitions.custom.fast}`,
            '&:hover': {
              backgroundColor: isActive
                ? theme.palette.leftNavigation.activeBg
                : 'rgba(0,0,0,0.05)',
            },
          }}
          onClick={onFilterIconClick}
        />
      </Stack>
    </Box>
  );
};

export default CustomAgMultiSelectFilter;
